import { lazy } from 'react';

import AuthGuard from 'utils/route-guard/AuthGuard';
import RoleGuard from 'utils/route-guard/RoleGuard';
import MainLayout from 'layout/MainLayout';
import Loadable from 'ui-component/Loadable';

const ListResultadosRecepcionView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListResultadosRecepcionView')));
const NewResultadosRecepcionView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewResultadosRecepcionView')));
const ListParametrosUnidadValidarView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListParametrosUnidadValidarView')));
const NewParametrosUnidadValidarView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewParametrosUnidadValidarView')));
const ListGruposParametrosUnidadView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListGruposParametrosUnidadView')));
const NewGruposParametrosUnidadView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewGruposParametrosUnidadView')));
const ListConfiguracionRecepcionProductosView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListConfiguracionRecepcionProductosView')));
const NewConfiguracionRecepcionProductosView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewConfiguracionRecepcionProductosView')));
const OrdenarConfiguracionRecepcionProductosView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/OrdenarConfiguracionRecepcionProductosView')));
const ConfiguracionReporteRecepcionView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ConfiguracionReporteRecepcionView')));
const ListTipoNovedadesView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListTipoNovedadesView')));
const NewTipoNovedadesView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewTipoNovedadesView')));
const ListTiposAlmacenamientoView = Loadable(lazy(() => import('views/administrator/TiposAlmacenamientoView/ListTiposAlmacenamientoView')));
const NewTiposAlmacenamientoView = Loadable(lazy(() => import('views/administrator/TiposAlmacenamientoView/NewTiposAlmacenamientoView')));
const ListAccionNovedadesView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListAccionNovedadesView')));
const NewAccionNovedadesView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewAccionNovedadesView')));
const ListMotivosDevolucionesComprasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListMotivosDevolucionesComprasView')));
const NewMotivosDevolucionesComprasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewMotivosDevolucionesComprasView')));
const ListCriteriosDevolucionesComprasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListCriteriosDevolucionesComprasView')));
const NewCriteriosDevolucionesComprasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewCriteriosDevolucionesComprasView')));
const ListCondicionesProductosDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListCondicionesProductosDevolucionVentasView')));
const NewCondicionesProductosDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewCondicionesProductosDevolucionVentasView')));
const ListMotivoDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListMotivoDevolucionVentasView')));
const NewMotivoDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewMotivoDevolucionVentasView')));
const ListEvaluacionDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/ListEvaluacionDevolucionVentasView')));
const NewEvaluacionDevolucionVentasView = Loadable(lazy(() => import('views/administrator/ArcsaRecepcionView/NewEvaluacionDevolucionVentasView')));

const ArcsaRecepcionRoutes = {
    path: '/',
    element: (
        <AuthGuard>
            <RoleGuard allowedRoles={['Administrador']}>
                <MainLayout />
            </RoleGuard>
        </AuthGuard>
    ),
    children: [
        {
            path: '/user/list-arcsa-recepcion-resultados',
            element: <ListResultadosRecepcionView />
        },
        {
            path: '/user/new-arcsa-recepcion-resultados/:id_resultado',
            element: <NewResultadosRecepcionView />
        },
        {
            path: '/user/list-arcsa-recepcion-unidades-validar',
            element: <ListParametrosUnidadValidarView />
        },
        {
            path: '/user/new-arcsa-recepcion-unidades-validar/:id_unidad_validar',
            element: <NewParametrosUnidadValidarView />
        },
        {
            path: '/user/list-arcsa-recepcion-grupos-parametros-unidad',
            element: <ListGruposParametrosUnidadView />
        },
        {
            path: '/user/new-arcsa-recepcion-grupos-parametros-unidad/:id_grupo',
            element: <NewGruposParametrosUnidadView />
        },
        {
            path: '/user/list-arcsa-recepcion-config-productos',
            element: <ListConfiguracionRecepcionProductosView />
        },
        {
            path: '/user/new-arcsa-recepcion-config-productos',
            element: <NewConfiguracionRecepcionProductosView />
        },
        {
            path: '/user/ordenar-arcsa-recepcion-config-productos',
            element: <OrdenarConfiguracionRecepcionProductosView />
        },
        {
            path: '/user/arcsa-recepcion-configuracion-reporte',
            element: <ConfiguracionReporteRecepcionView />
        },
        {
            path: '/user/list-arcsa-recepcion-tipo-novedades',
            element: <ListTipoNovedadesView />
        },
        {
            path: '/user/new-arcsa-recepcion-tipo-novedades/:id_tipo',
            element: <NewTipoNovedadesView />
        },
        {
            path: '/user/list-tipos-almacenamiento',
            element: <ListTiposAlmacenamientoView />
        },
        {
            path: '/user/new-tipos-almacenamiento/:id_tipo',
            element: <NewTiposAlmacenamientoView />
        },
        {
            path: '/user/list-arcsa-recepcion-accion-novedades',
            element: <ListAccionNovedadesView />
        },
        {
            path: '/user/new-arcsa-recepcion-accion-novedades/:id_accion',
            element: <NewAccionNovedadesView />
        },
        {
            path: '/user/list-arcsa-recepcion-motivos-devoluciones-compras',
            element: <ListMotivosDevolucionesComprasView />
        },
        {
            path: '/user/new-arcsa-recepcion-motivos-devoluciones-compras/:id_motivo',
            element: <NewMotivosDevolucionesComprasView />
        },
        {
            path: '/user/list-arcsa-recepcion-criterios-devoluciones-compras',
            element: <ListCriteriosDevolucionesComprasView />
        },
        {
            path: '/user/new-arcsa-recepcion-criterios-devoluciones-compras/:id_criterio',
            element: <NewCriteriosDevolucionesComprasView />
        },
        {
            path: '/user/list-arcsa-recepcion-condiciones-productos-devolucion-ventas',
            element: <ListCondicionesProductosDevolucionVentasView />
        },
        {
            path: '/user/new-arcsa-recepcion-condiciones-productos-devolucion-ventas/:id_condicion',
            element: <NewCondicionesProductosDevolucionVentasView />
        },
        {
            path: '/user/list-arcsa-recepcion-motivo-devolucion-ventas',
            element: <ListMotivoDevolucionVentasView />
        },
        {
            path: '/user/new-arcsa-recepcion-motivo-devolucion-ventas/:id_motivo',
            element: <NewMotivoDevolucionVentasView />
        },
        {
            path: '/user/list-arcsa-recepcion-evaluacion-devolucion-ventas',
            element: <ListEvaluacionDevolucionVentasView />
        },
        {
            path: '/user/new-arcsa-recepcion-evaluacion-devolucion-ventas/:id_evaluacion',
            element: <NewEvaluacionDevolucionVentasView />
        }
    ]
};

export default ArcsaRecepcionRoutes;
